// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleTwoToneSvg from "@ant-design/icons-svg/es/asn/EyeInvisibleTwoTone";
import AntdIcon from '../components/AntdIcon';

var EyeInvisibleTwoTone = function EyeInvisibleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleTwoToneSvg
  }));
};

EyeInvisibleTwoTone.displayName = 'EyeInvisibleTwoTone';
export default React.forwardRef(EyeInvisibleTwoTone);